import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var EnvelopeDistance = /*#__PURE__*/function () {
  function EnvelopeDistance() {
    _classCallCheck(this, EnvelopeDistance);
  }
  _createClass(EnvelopeDistance, null, [{
    key: "maxDistance",
    value: function maxDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
      var dist = EnvelopeDistance.distance(ax1, ay1, bx1, by1);
      dist = Math.max(dist, EnvelopeDistance.distance(ax1, ay1, bx2, by2));
      dist = Math.max(dist, EnvelopeDistance.distance(ax2, ay2, bx1, by1));
      dist = Math.max(dist, EnvelopeDistance.distance(ax2, ay2, bx2, by2));
      return dist;
    }
  }, {
    key: "distance",
    value: function distance(x1, y1, x2, y2) {
      var dx = x2 - x1;
      var dy = y2 - y1;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }, {
    key: "maximumDistance",
    value: function maximumDistance(env1, env2) {
      var minx = Math.min(env1.getMinX(), env2.getMinX());
      var miny = Math.min(env1.getMinY(), env2.getMinY());
      var maxx = Math.max(env1.getMaxX(), env2.getMaxX());
      var maxy = Math.max(env1.getMaxY(), env2.getMaxY());
      return EnvelopeDistance.distance(minx, miny, maxx, maxy);
    }
  }, {
    key: "minMaxDistance",
    value: function minMaxDistance(a, b) {
      var aminx = a.getMinX();
      var aminy = a.getMinY();
      var amaxx = a.getMaxX();
      var amaxy = a.getMaxY();
      var bminx = b.getMinX();
      var bminy = b.getMinY();
      var bmaxx = b.getMaxX();
      var bmaxy = b.getMaxY();
      var dist = EnvelopeDistance.maxDistance(aminx, aminy, aminx, amaxy, bminx, bminy, bminx, bmaxy);
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, aminx, amaxy, bminx, bminy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, aminx, amaxy, bmaxx, bmaxy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, aminx, amaxy, bmaxx, bmaxy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, amaxx, aminy, bminx, bminy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, amaxx, aminy, bminx, bminy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, amaxx, aminy, bmaxx, bmaxy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(aminx, aminy, amaxx, aminy, bmaxx, bmaxy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, aminx, amaxy, bminx, bminy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, aminx, amaxy, bminx, bminy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, aminx, amaxy, bmaxx, bmaxy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, aminx, amaxy, bmaxx, bmaxy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, amaxx, aminy, bminx, bminy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, amaxx, aminy, bminx, bminy, bmaxx, bminy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, amaxx, aminy, bmaxx, bmaxy, bminx, bmaxy));
      dist = Math.min(dist, EnvelopeDistance.maxDistance(amaxx, amaxy, amaxx, aminy, bmaxx, bmaxy, bmaxx, bminy));
      return dist;
    }
  }]);
  return EnvelopeDistance;
}();
export { EnvelopeDistance as default };